import { Injectable } from '@angular/core';

import { cloneDeep } from 'lodash';

import { DesignerConfigurationService } from './designer-configuration.service';
import { ControlDataModel, ControlLayoutModel } from '../types';

@Injectable({
  providedIn: 'root'
})
export class DataModelService {
  constructor(private configuration: DesignerConfigurationService) {}

  translateDataModel2LayoutModel(data: ControlDataModel): ControlLayoutModel {
    const children = new Array<ControlLayoutModel>();
    if (data.children) {
      for (const childData of data.children) {
        children.push(this.translateDataModel2LayoutModel(childData));
      }
    }

    return {
      component: this.configuration.findControlComponent(data.type),
      type: data.type,
      model: cloneDeep(data.model),
      children: children
    };
  }
}
